'use strict';

import { getVueTemplate } from '../_imports/utils/utils.common';
import BaseVueComponent from '../_imports/shared/base-vue-component.vue.common';
import CallToAction from '../cta/cta.vue';
import MarketoForm from '../forms/_imports/marketo-form.vue';

const modal = {
    template: getVueTemplate('modal'),
    mixins: [
        BaseVueComponent
    ],
    components: {
        CallToAction,
        MarketoForm
    },
    props: {
        id: String,
        name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isOpen: false,
            isClosing: false
        }
    },
    watch: {
        isOpen() {
            const bodyClass = 'with-lightbox-opened';

            if (this.isOpen) {
                document.querySelector('body').classList.add(bodyClass);
            } else {
                document.querySelector('body').classList.remove(bodyClass);
            }
        }
    },
    created() {
        document.addEventListener('open-modal', event => {
            if (event?.detail?.modalId === this.id) {
                this.open();
            }
        });
    },
    mounted() {
        this.moveModalToModalContainer();
    },
    methods: {
        close() {
            this.$emit('close');
            this.isClosing = true;
            
            document.documentElement.classList.remove('modal-is-visible');
            document.dispatchEvent(new CustomEvent('close-modal'));

            setTimeout(() => {
                this.isOpen = false;
                this.isClosing = false;
            }, 500);
        },
        closeOnClick(event) {
            if (this.isValidModalClosingElement(event.target)
                && event.buttons !== 2) {
                this.close();
            }
        },
        isValidModalClosingElement(element) {
            return element === this.$el
            || element === this.$refs['modal-container']
            || element === this.$refs['close-btn']
            || element === this.$refs['modal-body'];
        },
        moveModalToModalContainer() {
            const modalContainer = document.querySelector('[am-modal-container]');

            if (modalContainer) {
                const currentParent = this.$el.parentElement;
                
                if (currentParent) {
                    currentParent.removeChild(this.$el);
                    modalContainer.appendChild(this.$el);
                }
            }
        },
        open() {
            this.isOpen = true;
            document.documentElement.classList.add('modal-is-visible');
        }
    }
};

export default modal;